var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#bm';
                    var viewUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#view-bm';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 10',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };